import { forwardRef } from 'react';
import styled from 'styled-components';
import { useBanner } from '../../bannerProvider';
import type { SpacingBlockProps } from '../spacing';
import { SpacingBlock } from '../spacing';

export type SeparatorBlockProps = SpacingBlockProps & {
  size: number;
  lineStyle: string;
  color: string;
};

export const SeparatorBlock = forwardRef<HTMLDivElement, SeparatorBlockProps>(
  ({ size, lineStyle, color, style, ...forwardingProps }, forwardingRef) => {
    const { contentDirection } = useBanner();

    return (
      <SpacingBlock
        {...forwardingProps}
        ref={forwardingRef}
        style={{
          display: 'flex',
          flexDirection: contentDirection,
          justifyContent: 'center',
          ...style
        }}
      >
        <BaseSeparatorBlock
          _border={contentDirection === 'column' ? 'border-top' : 'border-left'}
          _size={Math.min(size, 20)}
          _style={lineStyle}
          _color={color}
        />
      </SpacingBlock>
    );
  }
);

const BaseSeparatorBlock = styled.div<{
  _border: 'border-top' | 'border-left';
  _size: number;
  _style: string;
  _color: string;
}>`
  ${({ _border, _size, _style, _color }) => `
    ${_border}: ${_size}px ${_style} ${_color};
  `}
`;
